<template>
  <div class="card">
    <div class="row">
      <div class="col-md-12">
        <div class="card-header">
          <div class="row">

            <div class="col-xs-3 col-md-1">
              <center>
                <i style="font-size: 300%; color: grey" class="fa fa-calendar"></i>
              </center>
              <br>
            </div>
            <div class="col-xs-9 col-md-11">
              <p class="title-card">
                <strong style="color: grey">Información del día</strong>
                <br>
                <small>Administra la información actual de AVANZA.</small>
              </p>
            </div>


          </div>
          <div class="row">
            <div class="col-md-12" v-if="rol == 1">
              <label for="">Sede:</label>
              <select class="form-control" v-model="emailsStats" @change="getEvents('filtro')"
                style="background-color: white;">
                <option v-for="sede in SedesProgramacion" :key="sede.sede" :value="sede"> {{ sede.sede }} </option>
              </select>
              <br>
            </div>
            <br>
            <div class="col-lg-3 col-sm-6" v-for="stats in statsCards" :key="stats.title">
              <stats-card style="box-shadow: 0px 0px 0px #999">
                <div class="icon-big text-center" :class="`icon-${stats.type}`" slot="header">
                  <i style="color: #e3097e" :class="stats.icon"></i>
                </div>
                <div class="numbers" slot="content">
                  <strong>
                    <p style="color: grey;">{{ stats.title }}</p>
                  </strong>
                  <strong style="font-size: 40px">{{ stats.value }}</strong>
                </div>
                <div class="stats" slot="footer">
                  <i :class="stats.footerIcon"></i>
                  <strong style="color:grey;">{{ stats.footerText }}</strong>
                </div>
              </stats-card>

            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <br>
        <div class="card-header">
          <div class="row">
            <div class="col-xs-3 col-md-1">
              <center>
                <i style="font-size: 300%; color: grey" class="fa fa-calendar"></i>
              </center>
              <br>
            </div>
            <div class="col-xs-9 col-md-11">
              <p class="title-card">
                <strong style="color: grey">Información por fechas</strong>
                <br>
                <small>Administra la información por fechas de avanza de AVANZA.</small>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-5">
              <label for="">Fecha inicio:</label>
              <input type="date" v-model="fechaInicio" class="form-control" />
            </div>
            <div class="col-md-5">
              <label for="">Fecha fin:</label>
              <input type="date" v-model="fechaFin" class="form-control" />
              <span v-if="fechaFin < fechaInicio">La fecha final no puede se menor a la fecha inicial</span>
            </div>
            <div class="col-md-1">
              <label for="" style="color:#f3f2ee;">dd</label>
              <button class="btn btn-success btn-fill" style="border-radius:5px;" @click="getTerapias()">
                Buscar <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          <div class="row">
            <br>
            <div class="col-md-4 col-md-4" v-for="stats in statsCards2" :key="stats.title">
              <stats-card style="box-shadow: 0px 0px 0px #999;">
                <div class="icon-big text-center" :class="`icon-${stats.type}`" slot="header">
                  <i style="color: #e3097e" :class="stats.icon"></i>
                </div>
                <div class="numbers" slot="content">
                  <strong>
                    <p style="color: grey;">{{ stats.title }}</p>
                  </strong>
                  <strong style="font-size: 40px">{{ stats.value }}</strong>
                </div>
                <div class="stats" slot="footer">
                  <i :class="stats.footerIcon"></i>
                  <strong style="color:grey;">{{ stats.footerText }}</strong>
                </div>
              </stats-card>
            </div>
          </div>


        </div>
        <div class="row">
          <br>
          <div class="col-xs-6">
            <div class="card-header">

              <chartjs-pie v-if="grafico == true" :labels="labels" :datasets="datasets" :option="option"></chartjs-pie>
              <br />

              <div class="row" v-if="resumen == true">
                <hr>
                <center>
                  <div class="col-md-12">
                    <strong>Resumen de la información:</strong>
                  </div>
                  <div class="col-md-6">
                    <strong style="color:#E3097E;"> CANCELADAS: {{ datasets[0].data[0] }} </strong>
                  </div>
                  <div class="col-md-6">
                    <strong style="color:#302254;"> REALIZADAS: {{ datasets[0].data[1] }} </strong>
                  </div>
                  <div class="col-md-12"> <br> <br>
                    <strong style="color:blue;"> TOTAL DE SESIONES: {{ datasets[0].data[0] + datasets[0].data[1]
                    }}</strong>
                  </div>
                </center>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="card-header">
              <chartjs-pie v-if="grafico == true" :labels="labels2" :datasets="datasets2" :option="option2"></chartjs-pie>
              <br />

              <div class="row" v-if="resumen == true">
                <hr>
                <center>
                  <div class="col-md-12">
                    <strong>Resumen de la información:</strong>
                  </div>
                  <div class="col-md-6">
                    <strong style="color:#E3097E;"> POLIZAS: {{ datasets2[0].data[0] }} </strong>
                  </div>
                  <div class="col-md-6">
                    <strong style="color:#302254;"> EPS: {{ datasets2[0].data[1] }} </strong>
                  </div>
                  <div class="col-md-6">
                    <strong style="color:grey;"> PARTICULARES: {{ datasets2[0].data[2] }} </strong>
                  </div>
                  <div class="col-md-6">
                    <strong style="color:red;"> PREPAGADAS: {{ datasets2[0].data[3] }} </strong>
                  </div>
                  <div class="col-md-12"> <br>
                    <strong style="color:blue;"> TOTAL DE SESIONES: {{ datasets2[0].data[0] + datasets2[0].data[1] +
                      datasets2[0].data[2] + datasets2[0].data[3] }}</strong>
                  </div>
                </center>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatsCard from "src/components/UIComponents/Cards/StatsCard.vue";
import axios from "axios";
export default {
  components: {
    StatsCard,
  },
  data() {
    return {
      cardterapias: true,
      fechaInicio: "",
      fechaFin: "",
      grafico: true,
      resumen: false,
      ip: "https://avanti-erp.com/",
      nuser: 0,
      rol: "",
      sede: '',
      SedesProgramacion: [],
      emailsStats: '',
      emailsProgramacionVar: [],
      statsCards: [
        {
          type: "info",
          icon: "fa fa-user",
          title: "Usuarios",
          footerText: "Usuarios activos",
          footerIcon: "fa fa-user",
          value: 0,
        },
        {
          type: "primary",
          icon: "fa fa-calendar",
          title: "Sesiones",
          footerText: "SS programadas hoy",
          footerIcon: "fa fa-calendar",
          value: 0,
        },
        {
          type: "info",
          icon: "fa fa-check",
          title: "SS Realiza.",
          footerText: "SS realizadas hoy",
          footerIcon: "ti-check",
          value: 0,
        },
        {
          type: "primary",
          icon: "fa fa-close",
          title: "SS Cancel.",
          footerText: "SS canceladas hoy",
          footerIcon: "ti-close",
          value: 0,
        },
      ],

      statsCards2: [
        {
          type: "primary",
          icon: "fa fa-calendar",
          title: "Sesiones",
          footerText: "SS programadas",
          footerIcon: "fa fa-calendar",
          value: 0,
        },
        {
          type: "info",
          icon: "fa fa-check",
          title: "SS Realiza.",
          footerText: "SS realizadas",
          footerIcon: "ti-check",
          value: 0,
        },
        {
          type: "primary",
          icon: "fa fa-close",
          title: "SS Cancel.",
          footerText: "SS canceladas",
          footerIcon: "ti-close",
          value: 0,
        },
      ],

      labels: ["Canceladas", "Realizadas"],
      datasets: [
        {
          data: [0, 0],
          backgroundColor: ["#E3097E", "#302254"],
        },
      ],
      option: {
        title: {
          display: true,
          position: "top",
          text: "Sesiones Programadas",
        },
      },
      labels2: ["POLIZAS", "EPS", "PARTICULARES", "PREPAGADAS"],
      datasets2: [
        {
          data: [0, 0, 0, 0, 0],
          backgroundColor: ["#E3097E", "#302254", "grey", "red", "blue"],
        },
      ],
      option2: {
        title: {
          display: true,
          position: "top",
          text: "Sesiones Autorizadas",
        },
      },
    };
  },
  created: function () {
    // this.getTerapias();
  },
  methods: {
    getNumberUsers: function (sede) {
      var token = localStorage.getItem("token");
      this.nuser = 0;
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/npacientes/" + sede,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.statsCards[0].value = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTerapias: function () {
      this.grafico = false;
      this.resumen = false;
      // this.grafico2 = false;
      this.datasets[0].data = [];
      this.datasets2[0].data = [];
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      let BASE_URL = `https://avanti-erp.com/api/terapiasDash/${this.fechaInicio}/${this.fechaFin}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          // console.log(res.data);
          // console.log(res, "esto que es?")
          this.grafico = false;
          this.datasets[0].data.push(res.data.canceladas);
          this.datasets[0].data.push(res.data.cumplidas);

          this.datasets2[0].data.push(res.data.poliza);
          this.datasets2[0].data.push(res.data.eps);
          this.datasets2[0].data.push(res.data.particular);
          this.datasets2[0].data.push(res.data.prepagadas);

          this.statsCards2[0].value = res.data.canceladas + res.data.cumplidas;
          this.statsCards2[1].value = res.data.cumplidas;
          this.statsCards2[2].value = res.data.canceladas;
          console.log(this.datasets[0].data);
          this.grafico = true;
          this.resumen = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEvents(moment) {
      var fechaActual = this.fechaEvento();
      var fechamas = this.fechamasdias(fechaActual);
      var email = '';

      if (moment == 'inicial') {
        email = localStorage.getItem("email");
      } else {
        email = this.emailsStats.correo
      }
      console.log(this.emailsStats.sede);
      this.getNumberUsers(this.emailsStats.sede);

      axios
        .get(
          `https://www.googleapis.com/calendar/v3/calendars/${email}/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=${fechaActual}T00:00:00-05:00&timeMax=${fechamas}T00:00:00-05:00&singleEvents=true&maxResults=1000`
        )
        .then((res) => {
          // this.res.data.items.length;
          // console.log(res.data.items.length);

          let datos = res.data.items;
          let eventos = [];
          let emailsProgramacion = this.emailsProgramacionVar;

          datos.forEach((element) => {
            if (emailsProgramacion.indexOf(element.organizer.email) != -1 && element.status != "cancelled") {
              eventos.push({
                start: element.start.dateTime,
                end: element.end.dateTime,
              });
            }
          });
          let sesiones = 0;
          let sesiones_necesarias = 0;
          eventos.forEach((element) => {
            sesiones = this.calcularMinutos(
              this.horaFormateada(element.start),
              this.horaFormateada(element.end)
            );
            sesiones_necesarias = sesiones_necesarias + sesiones;
          });

          // console.log(sesiones_necesarias);
          this.statsCards[1].value = sesiones_necesarias;
          if (moment != 'incial') {
            this.estadistica();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },

    devolverMinutos(horaMinutos) {
      return (
        parseInt(horaMinutos.split(":")[0]) * 60 +
        parseInt(horaMinutos.split(":")[1])
      );
    },

    calcularMinutos(inicio, fin) {
      // Cogemos la hora inicial y final y obtenemos los minutos totales
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        // Restamos los minutos finales con los minutos iniciales

        // console.log(
        //   "La cantidad de sesiones que se necesita es: " + (horaFinal - horaInicial / 60) + " sesion"
        // );
        let sesiones = (horaFinal - horaInicial) / 30;

        return Math.trunc(sesiones);
      } else {
        // document.getElementById("resultado").innerHTML =
        //   "La hora inicial tiene que ser inferior a la hora final";
      }
      // console.log(inicio)
    },

    estadistica() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      let fecha = this.fechaEvento();
      let sede = this.emailsStats.sede
      const BASE_URL = `${this.ip}api/estadisticaTerapias/${fecha}/${sede}`;

      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.statsCards[2].value = res.data.cumplidas;
          this.statsCards[3].value = res.data.canceladas;
          this.statsCards[1].value = res.data.programadas;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fechaEvento() {
      var fecha = new Date();
      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },
    fechamasdias: function (fecha) {
      var fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + 2);
      // console.log("fecha más 7 días", fecha);

      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },
    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      const BASE_URL = `${this.ip}api/emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then(res => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getNumberUsers(localStorage.getItem('sede'));
    this.emailsProgramacion();
    this.rol = localStorage.getItem("rol");
    this.emailsStats = { correo: localStorage.getItem("email"), sede: localStorage.getItem('sede') };
    let emailsProgramacion = localStorage.getItem('emailsProgramacion');
    this.emailsProgramacionVar = JSON.parse(emailsProgramacion);
    // this.getEvents('inicial');
    this.estadistica();
    window.document.title = "Avanti | Dashboard";
    if (localStorage.getItem('rol') != 1) {
      this.sede = localStorage.getItem('sede');
    }
  },
};
</script>
<style lang="css" scoped>
.card-header {
  padding-bottom: 10px !important;
  background-color: #f3f2ee;
  border-radius: 15px !important;
}

.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.card-chart {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  /* padding: 4%; */
  margin: 2px;
  background-color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ADashboard/ADashboard.vue